module.exports = {
  fullLang: '日本語',
  shortLang: '日本語',

  'blog.title': 'ブログ',
  'blog.back': '一覧に戻る',
  'blog.relatedArticlesHeader': '関連記事',
  'blog.readMore': '記事を読む',
  'blog.postsTagged': 'タグ付けされた記事',
  'blog.allTags': 'すべてのタグ',
  'blog.hideTags': 'タグを隠す',
  'blog.messageOne': 'ニュースレターの購読',
  'blog.messageTwo':
    'メルマガ登録すると新しい記事やアップデートをお知らせします',
  'blog.messageThree': '今すぐ登録',
  'blog.defaultAuthor': 'Ouster',
  'blog.url': '/jp/company/contact/newsletter/',
  'blog.homeUrl': '/jp/blog/',
  'blog.latestBlogPost': '最新記事',
  'nav.getADemo': 'デモのリクエスト',
  'nav.support': 'サポート',
  'cta.download': 'ダウンロード',
  'cta.readMore': '詳細はこちら',
  'cta.mostRecent': '最新情報',
  'cta.compare': 'センサーを追加',
  'downloads.title': 'ダウンロード',
  'downloads.seoTitle': 'Ouster ダウンロードセンター | Ouster',
  'downloads.ogDescription':
    'OusterのLIDARデータシート、ユーザーマニュアル、ファームウェア、ビジュアアライザーツール、その他ドキュメントをダウンロードする',
  'downloads.hardwareVersion': 'ハードウェアバージョン',
  'downloads.firmwareVersion': 'ファームウェアバージョン',
  'form.email': 'Email',
  'sortable.website': 'ウェブサイトを閲覧',
  'product.pricing': 'ボリュームディスカウント可能',
  'productComparison.select': 'センサー5つまで比較できます',
  'productComparison.selectShort': 'センサーを選ぶ',
  'productComparison.selected': '選択中',
  'productComparison.cancel': 'キャンセル',
  'productComparison.compare': '比較',
  'productComparison.sensorsSelected': '比較中のセンサー',
  'distributor.logo': 'ロゴ',
  'distributor.regions': '提供地域',
  'distributor.services': 'サービス',
  'careers.apply': 'このポジションに応募する',
  'careers.description': `Ouster（{location}）では、{job}のポジションを募集しています。詳細は求人票をご覧ください`,
  'careers.title': `{job} の職務内容　地域： {location} | Ouster`,
  'firmware.download': 'ダウンロード ',
  'firmware.copy': 'コピー',
  'firmware.copied': 'コピーしました',
  'firmware.note': '注意',
  'firmware.updates': 'アップデート',
  'firmware.sha256Hash': 'SHA256 HASH',
  'pointcloud.overlayTitle': 'ポイントクラウドとの連携',
  'pointcloud.overlayText':
    'クリックすると、デジタル点群のズーム、パン、ロレートができます。',
  'pointcloud.overlayButton': 'ローンチ',
}
